<div style="background-color: #fff; padding: 0 20px 0 20px;font-family: Arial" class="pdfViewer">
    <!-- <div style="position: absolute; top: 33px;" [ngStyle]="{width: (w -30- 6) + 'px'}">
        <div style="border-top: 1px solid black;height:70px; margin: 20px 80px;padding-top: 10px;">
            <div style="width:40%; text-align: left;display:inline-block; font-size: .9em;vertical-align: top;">
                <span>
                    <b>Project Name:</b> {{reportService.templateModel.description}}
                </span><br>
                <span>
                    <b>Address</b>: {{reportService.templateModel.addr}}
                </span><br>
                <span>
                    <b>Project No:</b> {{reportService.templateModel.pno}}
                </span>
            </div>
            <div
                style="width:40%; text-align: left; vertical-align: top;  display:inline-block; font-weight: bold;font-size: 1.1em;">
                <span>{{reportService.templateModel.caption}}</span>
            </div>
            <div [ngStyle]="{backgroundImage: 'url(' + reportService.templateModel.logo + ')'}"
                style="height: 70px; width:20%; background-position: center; background-repeat: no-repeat; background-size: contain;display:inline-block">
            </div>

        </div>
    </div> -->
    <div *ngFor="let i of pageNo">
        <div style="position: relative;" [ngStyle]="{width: (w - 20) + 'px', height: h + 'px'}">
            <div class="wt5" style="position: absolute; top: 33px;" [ngStyle]="{width: (w - 20 - 2) + 'px'}">
                <div class='row' [ngStyle]="{height: (h - 120)/3 + 'px'}">
                    <div style="margin: 10px 10px 10px 80px; width:38%; display:inline-block">
                        <div style="margin: 0;  width:100%; overflow:hidden; text-align: center;border:0px solid black  "
                            [ngStyle]="{height: (h - 180 - 80-70)/3 + 'px'}">
                            <!--<img style="border-style: none; margin-left:auto; margin-right:auto; max-height: 100%; max-width:100%; display:block;" class="center" [src]="photos[i].url" />-->
                            <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                class="center" [src]="photos[i].FILE_URL" />
                        </div>
                        <div style="margin-left: 4px; text-align: left;height:80px; overflow: hidden; font-size:.8em">
                            <span style="font-weight: bold;">Photo {{i+1}}</span>
                            <!--<span *ngIf="photos[i].title.length>0"> - {{photos[i].title}}</span>-->
                            <p *ngIf="photos[i].FILE_DESCRIPTION" style="margin: 0; text-align: left;"><b>Comments:
                                </b>{{photos[i].FILE_DESCRIPTION}}</p>
                        </div>
                        <!---->

                    </div>
                    <div *ngIf="photos.length>(i+1)"
                        style="margin: 10px 80px 10px 10px; width:38%; display:inline-block ">
                        <div style="margin: 0; width:auto; overflow:hidden; text-align: center; border:0px solid black "
                            [ngStyle]="{height: (h - 180 - 80-70)/3 + 'px'}">
                            <!--<img style="border-style: none; margin-left:auto; margin-right:auto; max-height: 100%; max-width:100%; display:block;" class="center" [src]="photos[i+1].url" />-->
                            <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                class="center" [src]="photos[i+1].FILE_URL" />
                        </div>
                        <div style="margin-left: 4px; text-align: left;height:80px; overflow: hidden; font-size:.8em ">
                            <span style="font-weight: bold;">Photo {{i+2}}</span>
                            <!--<span *ngIf="photos[i+1].title.length>0"> - {{photos[i+1].title}}</span>-->
                            <p *ngIf="photos[i+1].FILE_DESCRIPTION" style="margin: 0; text-align: left;"><b>Comments:
                                </b>{{photos[i+1].FILE_DESCRIPTION}}</p>
                        </div>
                        <!---->

                    </div>
                </div>
                <div class='row' [ngStyle]="{height: (h - 140)/3 + 'px'}">
                    <div *ngIf="photos.length>(i+2)"
                        style="margin: 0 10px 10px 80px; width:38%; display:inline-block">
                        <div style="margin: 0;  width:100%; overflow:hidden; text-align: center;border:0px solid black  "
                            [ngStyle]="{height: (h - 180 - 80-70)/3 + 'px'}">
                            <!--<img style="border-style: none; margin-left:auto; margin-right:auto; max-height: 100%; max-width:100%; display:block;" class="center" [src]="photos[i+2].url" />-->
                            <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                class="center" [src]="photos[i+2].FILE_URL" />
                        </div>
                        <div style="margin-left: 4px; text-align: left;height:80px;  overflow: hidden; font-size:.8em">
                            <span style="font-weight: bold;">Photo {{i+3}}</span>
                            <!--<span *ngIf="photos[i+2].title.length>0"> - {{photos[i+2].title}}</span>-->
                            <p *ngIf="photos[i+2].FILE_DESCRIPTION" style="margin: 0; text-align: left;"><b>Comments:
                                </b>{{photos[i+2].FILE_DESCRIPTION}}</p>
                        </div>
                        <!---->

                    </div>
                    <div *ngIf="photos.length>(i+3)"
                        style="margin: 0 80px 10px 10px; width:38%; display:inline-block ">
                        <div style="margin: 0; width:auto; overflow:hidden; text-align: center; border:0px solid black "
                            [ngStyle]="{height: (h - 180 - 80-70)/3 + 'px'}">
                            <!--<img style="border-style: none; margin-left:auto; margin-right:auto; max-height: 100%; max-width:100%; display:block;" class="center" [src]="photos[i+3].url" />-->
                            <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                class="center" [src]="photos[i+3].FILE_URL" />
                        </div>
                        <div style="margin-left: 4px; text-align: left;height:80px; overflow: hidden; font-size:.8em">
                            <span style="font-weight: bold;">Photo {{i+4}}</span>
                            <!--<span *ngIf="photos[i+3].title.length>0"> - {{photos[i+3].title}}</span>-->
                            <p *ngIf="photos[i+3].FILE_DESCRIPTION" style="margin: 0; text-align: left;"><b>Comments:
                                </b>{{photos[i+3].FILE_DESCRIPTION}}</p>
                        </div>
                        <!---->

                    </div>
                </div>
                <div class='row' [ngStyle]="{height: (h - 140)/3 + 'px'}">
                    <div *ngIf="photos.length>(i+4)"
                        style="margin: 0 10px 0 80px; width:38%; display:inline-block">
                        <div style="margin: 0;  width:100%; overflow:hidden; text-align: center;border:0px solid black  "
                            [ngStyle]="{height: (h - 180 - 80-70)/3 + 'px'}">
                            <!--<img style="border-style: none; margin-left:auto; margin-right:auto; max-height: 100%; max-width:100%; display:block;" class="center" [src]="photos[i+2].url" />-->
                            <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                class="center" [src]="photos[i+4].FILE_URL" />
                        </div>
                        <div style="margin-left: 4px; text-align: left;height:80px;  overflow: hidden; font-size:.8em">
                            <span style="font-weight: bold;">Photo {{i+5}}</span>
                            <!--<span *ngIf="photos[i+4].title.length>0"> - {{photos[i+4].title}}</span>-->
                            <p *ngIf="photos[i+4].FILE_DESCRIPTION" style="margin: 0; text-align: left;"><b>Comments:
                                </b>{{photos[i+4].FILE_DESCRIPTION}}</p>
                        </div>
                        <!---->

                    </div>
                    <div *ngIf="photos.length>(i+5)"
                        style="margin: 0 80px 0 10px; width:38%; display:inline-block ">
                        <div style="margin: 0; width:auto; overflow:hidden; text-align: center; border:0px solid black "
                            [ngStyle]="{height: (h - 180 - 80-70)/3 + 'px'}">
                            <!--<img style="border-style: none; margin-left:auto; margin-right:auto; max-height: 100%; max-width:100%; display:block;" class="center" [src]="photos[i+3].url" />-->
                            <img style="border-style: none; margin-left:auto; margin-right:auto; height: 100%; width:100%; display:block;"
                                class="center" [src]="photos[i+5].FILE_URL" />
                        </div>
                        <div style="margin-left: 4px; text-align: left;height:80px; overflow: hidden; font-size:.8em">
                            <span style="font-weight: bold;">Photo {{i+6}}</span>
                            <!--<span *ngIf="photos[i+5].title.length>0"> - {{photos[i+5].title}}</span>-->
                            <p *ngIf="photos[i+5].FILE_DESCRIPTION" style="margin: 0; text-align: left;"><b>Comments:
                                </b>{{photos[i+5].FILE_DESCRIPTION}}</p>
                        </div>
                        <!---->

                    </div>
                </div>
                <div style="border-top: 1px solid black;height:70px; margin: 0 80px;padding-top: 10px;">
                    <div style="width:40%; text-align: left;display:inline-block; font-size: .9em;vertical-align: top;">
                        <span>
                            <b>Project Name:</b> {{reportService.templateModel.description}}
                        </span><br>
                        <span>
                            <b>Address</b>: {{reportService.templateModel.addr}}
                        </span><br>
                        <span>
                            <b>Project No:</b> {{reportService.templateModel.pno}}
                        </span>
                    </div>
                    <div
                        style="width:40%; text-align: left; vertical-align: top;  display:inline-block; font-weight: bold;font-size: 1.1em;">
                        <span>{{reportService.templateModel.caption}}</span>
                    </div>
                    <div [ngStyle]="{backgroundImage: 'url(' + reportService.templateModel.logo + ')'}"
                        style="height: 70px; width:20%; background-position: center; background-repeat: no-repeat; background-size: contain;display:inline-block">
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>